import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicTextarea from "./BasicTextarea/BasicTextarea";
import BasicTextareaWithLabel from "./BasicTextarea/BasicTextareaWithLabel";

const TextareaPage = () => {
  return (
    <>
      <Paper elevation={0}>
        <PageTitleBox
          title={"Textarea"}
          description={"Text area let users enter and edit text."}
        />
        <Divider light />
        <BasicTextarea />
        <BasicTextareaWithLabel />
      </Paper>
    </>
  );
};

export default TextareaPage;
